import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-add-badge";

interface AddBadgeProps {
    size?: IconSizes;
}

const AddBadge = (props: AddBadgeProps) => {
    const { size = IconSizes.Medium } = props;
    return (
        <span className={CSS_CLASS_NAME}>
            <Icon
                size={size}
                cssClassName={`${CSS_CLASS_NAME}__icon`}
                type={Icons.Plus}
            />
            <span className="sr-only">{t("add")}</span>
        </span>
    );
};

export default AddBadge;
